<template>
  <div class="transaction-list">
    <template v-if="list.length > 0">
      <b-row class="transaction-list__row w-100">
        <b-col
          md="4"
          v-for="transaction in list"
          :key="transaction.id"
          class="d-flex"
        >
          <transaction-item :transaction="transaction"></transaction-item>
        </b-col>
      </b-row>
    </template>
    <template v-else>
      <b-row class="py-5 text-center">
        <b-col
          ><p>
            {{
              loading
                ? 'Please wait while we fetch your transactions...'
                : 'You have no ' + this.status + ' transactions currently...'
            }}
          </p></b-col
        >
      </b-row>
    </template>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * Transaction List
 * ==================================================================================
 **/

import { mapState, mapMutations, mapActions } from 'vuex'
import TransactionItem from '@/components/cards/TransactionItem'
import debounce from 'lodash/debounce'

export default {
  components: {
    TransactionItem
  },
  props: {
    status: {
      type: String,
      default: 'pending',
      validation: function(value) {
        return ['pending', 'past'].indexOf(value) !== -1
      }
    },
    active: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState({
      transactions: state => state.transaction.list,
      transactionsMeta: state => state.transaction.listMeta,
      pendingTransactions: state => state.transaction.pendingList,
      pendingTransactionsMeta: state => state.transaction.pendingListMeta
    }),

    list() {
      return this.isPending ? this.pendingTransactions : this.transactions
    },

    meta() {
      return this.isPending
        ? this.pendingTransactionsMeta
        : this.transactionsMeta
    },

    isPending() {
      return this.status === 'pending'
    }
  },
  data: function() {
    return {
      loading: false,
      isInitialized: false
    }
  },
  watch: {
    active: function(value) {
      if (value && !this.isInitialized) {
        this.init()
      }
    }
  },
  methods: {
    ...mapActions({
      getTransactions: 'transaction/getTransactions',
      addAlert: 'alert/addAlert'
    }),
    ...mapMutations({
      clearTransactions: 'transaction/clearTransactionList'
    }),

    init() {
      this.clearTransactions(this.isPending ? 'pendingList' : 'list')
      this.fetchTransactions()

      this.handleDebouncedScroll = debounce(this.handleScroll, 100)
      window.addEventListener('scroll', this.handleDebouncedScroll)

      this.isInitialized = true
    },

    async fetchTransactions(page = 1) {
      if (this.loading) return
      this.loading = true
      this.addAlert({
        label: 'Loading transactions...'
      })

      let params = {
        page: page,
        limit: 6,
        filters: {
          status: this.status,
          sorting: '-created_at'
        }
      }

      await this.getTransactions(params)
      this.loading = false
      this.$root.$emit('alert-message-remove')
    },

    handleScroll(e) {
      if (!this.meta) return
      const docEl = document.documentElement
      if (docEl.scrollTop + window.innerHeight === docEl.scrollHeight) {
        this.loadMore()
      }
    },

    loadMore() {
      if (this.active && this.meta.current_page < this.meta.last_page) {
        this.fetchTransactions(this.meta.current_page + 1)
      }
    }
  },
  async created() {
    if (!this.active) return
    this.init()
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleDebouncedScroll)
  }
}
</script>
<style scoped lang="scss">
.transaction-list {
  padding: 0 1.8rem;

  &__row {
    margin: 0 auto;

    .transaction-item {
      width: 100%;
      min-width: auto;
      margin-bottom: 45px;
    }
  }
}
</style>
